import React from 'react';
import Header from '../Header/Header';
import MainPage from "../MainPage/MainPage"
const Home = () => {
    return (
        <div>
           <Header></Header>
         <MainPage></MainPage>
        </div>
    );
};

export default Home;